<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Modification Recitateur</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field v-model="recitateurInfo.name" label="Titre" outlined required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-combobox
                    v-model="recitateurInfo.country"
                    :items="countryList"
                    item-text="name"
                    item-value="name"
                    :filter="filterCountry"
                    label="Pays"
                    placeholder="ex: Koweït / keweit"
                    outlined
                    clearable
                    @change="onCountryChange"
                  >
                  </v-combobox>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="recitateurInfo.flag"
                    label="Drapeau"
                    placeholder="kw"
                    outlined
                    maxlength="2"
                    clearable
                  >
                   
                  </v-text-field>
                </v-col>
                <!--    <v-col cols="12" sm="12" md="6" v-if="recitateurInfo.name">
                  <vue-upload-multiple-image
                    style="margin-left: 160px;"
                    v-model="images"
                    :data-images="images"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Image Principale"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :showEdit="false"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    :idUpload="imagesId"
                  >
                  </vue-upload-multiple-image>
                  <v-progress-linear
                    v-model="uploadPercentage"
                    v-if="showlowding"
                    style="max-width: 190px; margin-left: 160px;"
                    color="primary"
                    indeterminate
                    rounded
                    height="15"
                    ><strong
                      >{{ Math.ceil(uploadPercentage) }}%</strong
                    ></v-progress-linear
                  >
                </v-col>

                <v-col cols="12" sm="12" md="6"> </v-col> -->

                <v-col cols="12" sm="12" md="4" v-if="recitateurInfo.name">
                  <vue-upload-multiple-image style="margin-left: 160px" v-model="images" :data-images="images"
                    accept="image/*	" name="images" drag-text="Veuillez ajouter une image Sans arrière-plan"
                    browse-text="Browse image" primary-text="Image" mark-is-primary-text="Set default image"
                    :min-image="1" :multiple="false" :showEdit="false" popup-text="Description default image"
                    drop-text="Drag and drop" @upload-success="uploadImageSuccess" @before-remove="beforeRemove_BG"
                    :idUpload="images_BGId">
                  </vue-upload-multiple-image>
                  <v-progress-linear v-if="showlowding_BG && uploadPercentage_BG < 100"
                    style="max-width: 190px; margin-left: 160px" color="primary" indeterminate rounded
                    height="15"><strong>{{ Math.ceil(uploadPercentage_BG) }}%</strong></v-progress-linear>
                </v-col>
              </v-row>
              <v-col cols="12" sm="12" md="6">
                <v-row align="center">
                  <v-col cols="auto" style="margin-top: 16px">
                    <span>Statut Modification:</span>
                  </v-col>
                  <v-col cols="auto">
                    <v-switch v-model="recitateurInfo.isTranslated" hide-details inset></v-switch>
                  </v-col>
                  <v-col cols="auto" style="margin-top: 16px; margin-left: -20px">
                    <span style="color: #ff0000" v-if="!recitateurInfo.isTranslated">
                      La modification est incomplète
                    </span>
                    <span style="color: #00a325" v-if="recitateurInfo.isTranslated">
                      Modification Terminée
                    </span>
                  </v-col>
                </v-row>
              </v-col>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn :disabled="recitateurInfo.name.length <= 0" class="info" @click="UpdateRecitateur()">
                      Suivant
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-col cols="12" sm="12" md="3">
      <v-btn @click="AddSuratDialogue = true" class="info ml-6 mr-2 mt-4">
        Ajouter
      </v-btn>
    </v-col>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste Surat </v-card-title>
      <v-text-field style="padding: 15px" v-model="search" append-icon="mdi-magnify" label="Search" single-line
        hide-details clearable :search="search"></v-text-field>
      <v-data-table :search="search" :loading="isLoadingTables" loading-text="Loading..." :footer-props="{
        'items-per-page-options': [5, 10, 15, 30],
      }" :headers="headers" :items="recitateurInfo.recitateurSuratResponseList" class="elevation-1" item-key="id">
        <template v-slot:[`item.suratLink`]="{ item }">
          <vuetify-audio style="height: 150px; margin-top: 10px; margin-bottom: 10px" :file="item.suratLink"
            :autoPlay="false" :downloadable="false" :flat="false" :playIcon="icons.mdiPlay" :pauseIcon="icons.mdiPause"
            :stopIcon="icons.stopIcon" :refreshIcon="icons.mdiRefresh" :downloadIcon="icons.mdiDownload"
            :volumeHighIcon="icons.mdiVolumeHigh" :volumeMuteIcon="icons.mdiVolumeMute"></vuetify-audio>
        </template>
        <template v-slot:[`item.isLocked`]="{ item }">
          <v-row>
            <v-switch :loading="item.isLoading" v-model="item.isLocked" hide-details inset
              @change="handleSwitchLocke(item)"></v-switch>

            <v-icon color="primary" style="margin-top: 15px" v-if="item.isLocked">
              {{ icons.mdiLock }}
            </v-icon>
            <v-icon color="#00a325" style="margin-top: 15px" v-if="!item.isLocked">
              {{ icons.mdiLockOpen }}
            </v-icon>
          </v-row>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="redirectToEditVersetStartTime(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionAction(item)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
        <template v-slot:[`item.isTranslated`]="{ item }">
          <v-row>
            <v-switch :loading="item.LoadingTranslated" v-model="item.isTranslated" hide-details
              :color="item.LoadingTranslated ? '#ff0000' : '#16b1ff'" inset
              @change="handleSwitchisTranslated(item)"></v-switch>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="AddSuratDialogue" max-width="850">
      <v-card>
        <v-card-title class="text-h6">
          Ajouter une Sourate au Récitant
        </v-card-title>
        <v-row style="margin: 20px">
          <v-col cols="6" sm="6" md="6">
            <v-select v-model="surat" clearable label="Surat" :items="suratArray" item-text="arabic_translated_name"
              item-value="suratId" outlined></v-select>
          </v-col>
          <v-col cols="6" sm="6" md="6">
            <label>Audio File
              <input type="file" accept="audio/*" @change="handleAudioUpload($event)" />
              <v-progress-linear v-if="showlowding_audio" style="max-width: 300px; margin-top: 10px" color="primary"
                indeterminate rounded height="6"></v-progress-linear>
            </label>
          </v-col>
        </v-row>
        <v-row align="center" style="margin: 20px" v-show="echec">
          <v-col cols="6" sm="6" md="6"></v-col>
          <v-col cols="6" sm="6" md="6">
            <span style="color: red">Échec d'upload du fichier audio</span>
          </v-col>
        </v-row>
        <v-row align="center" style="margin: 20px">
          <v-col cols="auto" style="margin-top: 20px">
            <span>Premium:</span>
          </v-col>
          <v-col cols="auto">
            <v-switch v-model="model" hide-details inset></v-switch>
          </v-col>
          <v-col cols="auto" style="margin-top: 16px; margin-left: -20px">
            <v-icon color="#00a325" v-if="!model">
              {{ icons.mdiLockOpen }}
            </v-icon>
            <v-icon color="warning" v-if="model">
              {{ icons.mdiLock }}
            </v-icon>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1 error" text @click="AddSuratDialogue = false">
            Annuler
          </v-btn>

          <v-btn :disabled="surat === null || fileId === null" color="info darken-1 " @click="ajoutSuratToRecitateur()"
            text>
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteRecitateurSurat" max-width="530">
      <v-card>
        <v-card-title class="text-h6">
          Etes vous sur de vouloir supprimer le Surat Recitateur ?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1 error" text @click="dialogDeleteRecitateurSurat = false">
            Annuler
          </v-btn>

          <v-btn color="info darken-1 " text @click="deleteSuratRecitateur()">
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-dialog v-model="dialogConfirmeEditRecitateur" max-width="600">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir Modifier le Recitateur ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogConfirmeEditRecitateur = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="UpdateRecitateur()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>
<script>
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { VuetifyAudio } from "vuetify-audio";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import {
  mdiLockOpen,
  mdiLock,
  mdiPlay,
  mdiPause,
  mdiPlus,
  mdiStop,
  mdiRefresh,
  mdiDownload,
  mdiVolumeHigh,
  mdiVolumeMute,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
} from "@mdi/js";
import axios from "axios";
import store from "../../store/image";
import Constant from "@/utils/constants";
import COUNTRIES from "@/utils/countries";
import {
  getAllSurat,
} from "@/views/qorani/services/services";
export default {
  components: { VueUploadMultipleImage, VuetifyAudio },
  data() {
    return {
      echec: false,
      snackbar: false,
      text: "Échec d'upload du fichier audio",
      timeout: 4000,
      recitateurs: [],
      imageInfo: {
        fileName: "",
        fileUrl: "",
      },
      search: "",
      uploadPercentage_BG: null,
      fakePercentage_BG: null,
      uploadPercentage: null,
      fakePercentage: null,
      showlowding: false,
      showlowding_BG: false,
      showlowding_audio: false,
      imagesId: "0",
      images_BGId: "1",
      dialogConfirmeEditRecitateur: false,
      dialogVerset: false,
      idSuratSupprimmer: null,
      dialogDeleteRecitateurSurat: false,
      icons: {
        mdiLockOpen,
        mdiLock,
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
        mdiPlay,
        mdiPause,
        mdiStop,
        mdiRefresh,
        mdiDownload,
        mdiVolumeHigh,
        mdiVolumeMute,
      },
      suratRecitateur: {
        suratId: null,
        recitateurId: null,
        audioBookId: null,
        isLocked: false,
      },
      model: false,
      fileId: null,
      surat: null,
      suratArray: [],
      AddSuratDialogue: false,
      recitateurSuratArray: [],
      images: [],
      images_BG: [],
      isLoadingTables: false,
      countryList: COUNTRIES,
      recitateurInfo: {
        recitateurId: "",
        name: "",
        country: null,
        flag: null,
        imgId: "",
        imageUrl: "",
        isTranslated: false,
        recitateurSuratResponseList: [],
        imgSansBackgroundUrl: "",
        imgSansBackgroundUrlId: "",
      },
      recitateur: {
        name: "",
        country: null,
        flag: null,
        isTranslated: false,
        fileUrlDBId: "",
      },
      VersetBySurateArray: [],
      headers: [
        { text: "Surat en Arabe", value: "arabic_text", align: "center" },
        { text: "Surat en Français", value: "french_text" },
        { text: "Surat en anglais", value: "english_text" },
        { text: "Premium", value: "isLocked" },
        { text: "Traduction", value: "isTranslated" },
        { text: "File", value: "suratLink", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
    };
  },
  // async beforeRouteEnter(to, from, next) {
  //   const recitateurId = to.params.id;
  //   try {
  //     const response = await axios.get(
  //       `${Constant.QORANI}recitateur/get/${recitateurId}`
  //     );
  //     next((vm) => {
  //       vm.recitateurInfo = response.data;
  //       vm.recitateurInfo.recitateurSuratResponseList.forEach((item) => {
  //         item.isLoading = false;
  //         item.LoadingTranslated = false;
  //       });
  //     });
  //   } catch (error) {
  //     console.error("Error fetching product details:", error);
  //     next(null);
  //   }
  // },
  async beforeRouteEnter(to, from, next) {
    const recitateurId = to.params.id;
    try {
      const response = await axios.get(
        `${Constant.QORANI}recitateur/get/${recitateurId}`
      );
      next((vm) => {
        vm.recitateurInfo = response.data;
        const imagePath = response.data.fileUrlDBId
          ? vm.getImageUrl(response.data.fileUrlDBId)
          : response.data.fileUrlDBId;
          console.log("imagePath:", imagePath);
        /*
        const imgSansBackgroundUrl =
          vm.getImageUrl(response.data.fileUrlDBId) ||
          response.data.imgSansBackgroundUrl;
        */
       console.log(response.data);
       
        vm.images.push({
          name: "",
          path: imagePath,
          highlight: 1,
          default: 1,
        });
      });
    } catch (error) {
      console.error("Error fetching theme details:", error);
      next(null);
    }
  },
  methods: {
    async filterFirebaseUrls() {
      for (const theme of this.recitateurs) {
        const firebaseUrls = theme.listFileUrl.filter((url) =>
          url.includes("firebase")
        );
        if (firebaseUrls.length > 0) {
          console.log(
            `theme ID: ${recitateurId.id}, Firebase URLs:`,
            firebaseUrls
          );
          await this.uploadFirebaseUrls(recitateurId.id, firebaseUrls);
        }
      }
    },

    async uploadFirebaseUrls(recitateurId, firebaseUrls) {
      const formDataToSend = new FormData();

      try {
        // Fetch the image as a blob
        const response = await fetch(firebaseUrls);
        const blob = await response.blob();

        formDataToSend.append("file", blob, "image.jpg");
      } catch (error) {
        console.error(
          `Error converting image URL to File for Theme ID ${recitateurId}:`,
          error
        );
        return; // Exit function in case of an error
      }

      console.log(formDataToSend);

      try {
        // Upload the image
        const response = await fetch(`${Constant.QORANI}fileDB/upload`, {
          method: "POST",
          body: formDataToSend,
        });

        if (!response.ok) {
          const errorResponse = await response.json();
          console.error(
            `Failed to upload URLs for Theme ID:`,
            response.statusText,
            errorResponse
          );
        } else {
          const result = await response.json();
          console.log(`Successfully uploaded URLs for Theme ID:`, result);

          if (result.id) {
            this.recitateur.fileUrlDBId = result.id;
            this.recitateur.name = this.recitateurInfo.name;
            this.recitateur.country = this.recitateurInfo.country ? this.recitateurInfo.country.trim() : null;
            this.recitateur.flag = this.recitateurInfo.flag ? this.recitateurInfo.flag.trim() : null;
            this.recitateur.isTranslated = this.recitateurInfo.isTranslated;
            console.log("fileUrlDBId:", this.recitateur.fileUrlDBId);

            try {
              // Perform the theme update
              const responseCategorie = await fetch(
                Constant.QORANI +
                "recitateur/edit/" +
                this.recitateurInfo.recitateurId,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(this.recitateur),
                }
              );

              if (!responseCategorie.ok) {
                const errorResponse = await responseCategorie.json();
                console.error(
                  "Failed to update theme:",
                  responseCategorie.statusText,
                  errorResponse
                );
              } else {
                const resultCategorie = await responseCategorie.json();
                console.log("Successfully updated theme:", resultCategorie);
              }
            } catch (error) {
              console.error(`Error while updating theme for ID :`, error);
            }
          }
        }
      } catch (error) {
        console.error(`Error while uploading URLs for Theme ID:`, error);
      }
    },
    async loadImage(item) {
      if (item.fileUrlDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

          item.svgContent = svgContent; // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        item.imgUrl = `${Constant.QORANI}fileDB/files/${item.fileUrlDBId}`;
      }
    },

    filterCountry(item, queryText) {
      if (!queryText) return true;
      const query = queryText;
      return (
        item.name.includes(query) ||
        item.code.includes(query)
      );
    },
    onCountryChange(val) {
      if (!val) {
        this.recitateurInfo.country = "";
        return;
      }
        this.recitateurInfo.country = val.name;
          this.recitateurInfo.flag = val.code;
    },
   
    getImageUrl(fileUrlDBId) {
      return `${Constant.QORANI}fileDB/files/${fileUrlDBId}`;
    },
    async redirectToEditVersetStartTime(item) {
      this.$router.push({
        name: "VersetStartTime",
        params: {
          suratId: item.suratId,
          recitateurId: this.recitateurInfo.recitateurId,
        },
      });
    },

    async deleteSuratRecitateur() {
      const responseCategorie = await fetch(
        Constant.QORANI +
        `recitateur/removeSurat/${this.idSuratSupprimmer}/from/${this.recitateurInfo.recitateurId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteRecitateur = false;
      }
    },
    async handleSwitchLocke(item) {
      // item.isLoading = true;
      try {
        var response = await axios.get(
          Constant.QORANI + "recitateur/editRecitateurSuratItem/" + item.id
        );
      } catch (error) {
        console.error("Error:", error);
      } finally {

        // item.isLoading = false;
        // setTimeout(() => {
        //   item.isLoading = false;
        //   window.location.reload();
        // }, 3000);
      }
    },
    async handleSwitchisTranslated(item) {
      // item.LoadingTranslated = true;
      try {
        const response = await axios.get(
          Constant.QORANI +
          "recitateur/editRecitateurSuratItemTranslated/" +
          item.id
        );
      } catch (error) {
        console.error("Error:", error);
      } finally {
        // setTimeout(() => {
        //   item.LoadingTranslated = false;
        //   window.location.reload();
        // }, 3000);
      }
    },
    suppressionAction(item) {
      this.idSuratSupprimmer = item.suratId;
      // this.dialogDeleteRecitateurSurat = true;
      this.deleteSuratRecitateur();
    },
    async ajoutSuratToRecitateur() {
      this.suratRecitateur.suratId = this.surat;
      this.suratRecitateur.recitateurId = this.recitateurInfo.recitateurId;
      this.suratRecitateur.audioBookId = this.fileId;

      this.suratRecitateur.isLocked = this.model;
      console.log(JSON.stringify(this.suratRecitateur));

      const responseCategorie = await fetch(
        Constant.QORANI + "recitateur/addSuratLinkToRecitateur",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.suratRecitateur),
        }
      );

      try {
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout de la surat, veuillez réessayez plus tard, Merci."
        );
      }
    },
    handleAudioUpload(event) {
      this.echec = false;
      this.snackbar = false;
      const suratPhonetic = this.suratArray.find(
        (surat) => surat.suratId === this.surat
      ).arabic_translated_name;

      this.showlowding_audio = true;
      const file = event.target.files[event.target.files.length - 1];
      const apiEndpoint = `${Constant.QORANI}files/uploadABS`;
      const folder = "e7d4adf9-bf21-4b6b-8938-341796d7bd4e";
      const library = "01590bfa-c13c-4b34-a2b3-b056875f0368";
      const title = this.recitateurInfo.name + "-" + suratPhonetic;
      const recitateurId = this.recitateurInfo.recitateurId;
      const suratId = this.surat;
      console.log(title);

      const customFormData = new FormData();
      customFormData.append("file", file);
      customFormData.append("folder", folder);
      customFormData.append("library", library);
      customFormData.append("title", title);
      customFormData.append("recitateurId", recitateurId);
      customFormData.append("suratId", suratId);
      customFormData.append("fromPostman", false);

      axios
        .post(apiEndpoint, customFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.id) {
            console.log("Audio upload success:", response.data);
            this.fileId = response.data.id;
            this.showlowding_audio = false;
            event.target.value = null;
          } else {
            this.fileId = response.data.id;
            this.snackbar = true;
            this.showlowding_audio = false;
            this.echec = true;
            event.target.value = null;
          }
        })
        .catch((error) => {
          console.error("Error uploading audio:", error);
          this.showlowding_audio = false;
        });
    },
    async UpdateRecitateur() {
      // const imageId = store.state.imageId;
      // this.recitateur.fileUrlDBId = imageId;

      this.recitateur.name = this.recitateurInfo.name;
      this.recitateur.country = this.recitateurInfo.country ? this.recitateurInfo.country.trim() : null;
      this.recitateur.flag = this.recitateurInfo.flag ? this.recitateurInfo.flag.trim() : null;
      this.recitateur.isTranslated = this.recitateurInfo.isTranslated;
      //this.recitateur.imgUrlId = this.recitateurInfo.imgId;

      // this.recitateur.imgSansBackgroundUrlId = this.recitateurInfo.imgSansBackgroundUrlId;
      const responseCategorie = await fetch(
        Constant.QORANI + "recitateur/edit/" + this.recitateurInfo.recitateurId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.recitateur),
        }
      );

      try {
        this.$router.push({
          name: "Recitateur",
        });
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du theme, veuillez réessayez plus tard, Merci."
        );
      }
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
       const imageId = store.state.imageId;
       this.recitateur.fileUrlDBId = imageId;
        console.log("Image id :", imageId);
      } catch (error) {
        console.error("Failed to upload image:", error);
      }
    },
    // async uploadImageSuccess(formData, index, fileList) {
    //   try {
    //     await store.dispatch("uploadImageSuccess", { formData, index, fileList });
    //     const imageId = store.state.imageId;
    //     console.log("Image id :", imageId);
    //   } catch (error) {
    //     console.error("Failed to upload image:", error);
    //   }
    // },
    beforeRemove_BG(index, done, fileList) {
      this.showlowding_BG = false;
      this.fakePercentage_BG = 0;
      this.uploadPercentage_BG = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images_BG.indexOf(fileList[index].path);
        this.recitateurInfo.imgSansBackgroundUrl = "";
        this.recitateurInfo.imgSansBackgroundUrlId = "";
        if (index > -1) {
          this.images_BG.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.images.indexOf(fileList[index].path);
        this.recitateurInfo.imageUrl = "";
        this.recitateurInfo.imgId = "";
        if (index > -1) {
          this.images.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    convertImagePathToFile(element) {
      const byteString = atob(element.path.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/jpeg" });

      return new File([blob], element.name);
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.suratArray = await getAllSurat();
/*
    this.images.push({
      name: "",
      path: this.recitateurInfo.imageUrl,
      highlight: 1,
      default: 1,
    });
    this.images_BG.push({
      name: "",
      path: this.recitateurInfo.imgSansBackgroundUrl,
      highlight: 1,
      default: 1,
    });
    */
    this.isLoadingTables = false;
  },
};
</script>
